import React from 'react'
import styles from "./styles.module.scss";
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { hardcodeDropdown, findLabelByValue } from "./constants";
import { regex } from "views/pages/manage/common/constant/regex/index";


const ContactDetails = ({ headerData, setHeaderData, listing = false, purchaseType }) => {
    return (
        <>
            <div className={`${styles["header-style"]} `}>
                <AInput
                    value={headerData?.Telephone_no}
                    handler={(val) => setHeaderData((prev) => ({ ...prev, Telephone_no: val }))}

                    placeholder={"Telephone"}
                    maxLength={10}
                    regex={regex?.numeric}
                />
            </div>

            <div className={`${styles["header-style"]} `}>
                <AAutoComplete
                    currentValue={headerData?.Department}
                    handleChange={(value) => {
                        setHeaderData((prev) => ({ ...prev, Department: value }))
                    }}
                    items={hardcodeDropdown?.Department}
                    isMulti={false}
                    placeholder={"Department"}
                    // autoFocus={params?.hasFocus}
                    isClearable={true}
                />
            </div>

            <div className={`${styles["header-style"]} `}>
                <AInput
                    value={headerData?.Email_id}
                    handler={(val) => setHeaderData((prev) => ({ ...prev, Email_id: val }))}
                    placeholder={"Email"}
                    maxLength={50}
                />
            </div>
        </>
    )
}

export default ContactDetails;